class RepairFormHandler {
  constructor(wrapperId) {
	this.wrapper = document.getElementById(wrapperId);
	this.serialContainer = this.wrapper.querySelector('.serial-number-container');
	this.addButton = this.serialContainer.querySelector('.add-serial');
	this.submitButton = this.wrapper.querySelector('#submit-button');

	this.api = new CustomerPortalAPI();

	this.addListeners();
  }

  addListeners() {
	this.addButton.addEventListener('click', this.addSerialField.bind(this));
	this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
  }

  addSerialField() {
	const newField = document.createElement('div');
	newField.className = 'serial-number-field';
	newField.innerHTML = `
	  <input type="text" class="field__input" name="serial_numbers[]" placeholder="Enter serial number" required />
	  <label class="field__label">Enter serial number</label>
	  <span class="remove-serial">✕</span>
	`;
	this.serialContainer.insertBefore(newField, this.addButton);
	const removeBtn = newField.querySelector('.remove-serial');
	removeBtn.style.display = 'block';
	removeBtn.addEventListener('click', () => newField.remove());
  }

  collectFormData() {
	const getVal = id => this.wrapper.querySelector(`#${id}`)?.value.trim();
	const getChecked = id => this.wrapper.querySelector(`#${id}`)?.checked;

	const serialNumbers = Array.from(
	  this.wrapper.querySelectorAll('input[name="serial_numbers[]"]')
	).map(el => el.value.trim()).filter(Boolean);

	return {
	  customer_id: window.FMCustomer?.id || '',
	  name: getVal('name'),
	  email: getVal('email'),
	  phone: getVal('phone'),
	  address: getVal('address'),
	  city: getVal('city'),
	  province: getVal('province'),
	  postal_code: getVal('postal_code'),
	  message: getVal('message'),
	  pickup_requested: getChecked('pickup_requested') ? 'yes' : '',
	  serial_numbers: serialNumbers
	};
  }

  async handleSubmit() {
	const data = this.collectFormData();
	const missing = [];
	const fieldLabels = {
	  name: 'Full Name',
	  email: 'Email Address',
	  phone: 'Phone Number',
	  address: 'Address',
	  city: 'Town/City',
	  province: 'Province',
	  postal_code: 'Postal Code',
	  message: 'Problem Description',
	  serial_numbers: 'Serial Numbers'
	};
  
	// Clear previous errors
	this.wrapper.querySelectorAll('.field__input').forEach(input => {
	  input.classList.remove('field--error');
	});
  
	for (const [key, value] of Object.entries(data)) {
	  if (key === 'pickup_requested') continue; // Not required
  
	  if (Array.isArray(value)) {
		if (!value.length) {
		  missing.push(fieldLabels[key] || key);
		  this.markFieldGroupError('serial_numbers[]');
		}
	  } else if (!value) {
		missing.push(fieldLabels[key] || key);
		this.markFieldError(key);
	  }
	}
  
	// Extra validation: email and phone format
	const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email);
	const phoneValid = /^[\d\-\+\s\(\)]+$/.test(data.phone);
  
	if (data.email && !emailValid) {
	  missing.push('Valid Email Address');
	  this.markFieldError('email');
	}
  
	if (data.phone && !phoneValid) {
	  missing.push('Valid Phone Number');
	  this.markFieldError('phone');
	}
  
	if (missing.length) {
	  alert(`Please correct the following:\n\n- ${missing.join('\n- ')}`);
	  return;
	}
  
	const result = await this.api.postRepairForm(data);
  
	if (result.ok) {
	  // Hide form intro
		const intro = document.querySelector('.rich-text, .section-intro');
		if (intro) intro.remove();

		let recordId = null;
		try {
		  const parsed = JSON.parse(result.text);
		  recordId = parsed.recordIds?.[0] ?? null;
		} catch (e) { /* ignore */ }

		const refLine = recordId
		  ? `<p style="margin: 0; font-family: Manrope, sans-serif; font-size: 15px; color: #374151;"><strong>Reference #:</strong> ${recordId}</p>`
		  : '';

		// Replace form with success message and reset button
		this.wrapper.innerHTML = `
		  <div style="display: flex; flex-direction: column; align-items: center; padding: 60px 20px; text-align: center; max-width: 500px; margin: 0 auto;">
		    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: 24px;">
		      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
		      <polyline points="22 4 12 14.01 9 11.01"></polyline>
		    </svg>
		    <h2 style="margin: 0 0 12px 0; font-family: Manrope, sans-serif; color: #121212; font-size: 28px; font-weight: 600;">Submission Successful</h2>
		    <p style="margin: 0 0 24px 0; font-family: Manrope, sans-serif; color: #666; font-size: 16px; line-height: 1.5;">Thank you! Your repair request has been submitted. Our team will be in touch shortly.</p>
		    ${refLine ? `<div style="background: #f8f9fa; border-radius: 8px; padding: 20px 30px; width: 100%; margin-bottom: 24px;">${refLine}</div>` : ''}
		    <button class="button" id="reset-form">Submit Another Request</button>
		  </div>
		`;
	  
		// Add listener to reset the form by reloading the page
		document.getElementById('reset-form').addEventListener('click', () => {
		  location.reload();
		});
		
	} else {
	  this.wrapper.innerHTML = `
		<div class="error">
		  <h2>❌ Something Went Wrong</h2>
		  <p>We're sorry, but your repair request could not be submitted at this time. Please try again later.</p>
		  <button class="button" id="retry-form">Try Again</button>
		</div>
	  `;
	  
	  // Add listener to reload the page
	  document.getElementById('retry-form').addEventListener('click', () => {
		location.reload();
	  });
	}
  }
  
  markFieldError(id) {
	const field = this.wrapper.querySelector(`#${id}`);
	if (field) field.classList.add('field--error');
  }
  
  markFieldGroupError(name) {
	this.wrapper.querySelectorAll(`input[name="${name}"]`).forEach(input => {
	  if (!input.value.trim()) {
		input.classList.add('field--error');
	  }
	});
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RepairFormHandler('repair-form-wrapper');
});